module.exports = __webpack_public_path__ + "static/headshot-rob-fry.e03993c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-rob-fry.jpg
// module id = 140
// module chunks = 35783957827783 152909308826437